import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative inline-flex animate-gift-bounce" }
const _hoisted_2 = { class: "absolute -bottom-1 -right-1 inline-flex h-[14px] w-[14px] items-center justify-center rounded-full bg-background" }
const _hoisted_3 = ["aria-label"]

import { computed } from 'vue';
import { Gift, Check } from 'lucide-vue-next';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveGiftCart',
  setup(__props) {

const { cart, channel } = useContext();
const { websiteText } = useWebsiteTexts();

const cartRow = computed<any>(() => cart.value?.rows?.[0]);
const hasGiftInCart = computed(() => !!cartRow.value);

const cartRowProductName = computed(
  () => cartRow.value?.variantName || cartRow.value?.baseProductName || '',
);

const checkoutUrl = computed(() => channel.value?.checkoutUrl || '');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (hasGiftInCart.value && checkoutUrl.value)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: checkoutUrl.value,
        title: cartRowProductName.value,
        class: "relative inline-flex items-center text-foreground transition-colors hover:opacity-70",
        "aria-label": cartRowProductName.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_unref(Gift), { class: "h-5 w-5" }),
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_unref(Check), {
                class: "h-[10px] w-[10px] text-success",
                "stroke-width": 3
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["to", "title", "aria-label"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "relative inline-flex cursor-default items-center text-foreground",
        "aria-label": _unref(websiteText)('getmygift__header__nogiftcardselected').value
      }, [
        _createVNode(_unref(Gift), { class: "h-5 w-5" })
      ], 8, _hoisted_3))
}
}

})